import { memo } from 'react';
import { useListeners } from '@client/hooks/redux.hooks';
import { signedOutListeners } from '@client/components/Main/common/signed-out.listeners';

export const SignedOutListeners = memo(() => {
  useListeners(signedOutListeners);

  return null;
});

export default SignedOutListeners;
